import React from 'react'

const Method = () => {
  const methods = [
    {
      icon: 'fas fa-lightbulb',
      title: 'یادگیری مفهومی',
      description: 'تمرکز بر درک عمیق مفاهیم به جای حفظ فرمول‌ها'
    },
    {
      icon: 'fas fa-hands-helping',
      title: 'یادگیری تعاملی',
      description: 'تشویق مشارکت فعال دانش‌آموزان در فرآیند یادگیری'
    },
    {
      icon: 'fas fa-tasks',
      title: 'تمرین عملی',
      description: 'استفاده از مثال‌های واقعی و تمرینات متنوع'
    },
    {
      icon: 'fas fa-heart',
      title: 'صبر و همدلی',
      description: 'ایجاد محیطی امن و تشویق‌کننده برای یادگیری'
    }
  ]

  return (
    <section id="method" className="method">
      <div className="container">
        <h2 className="section-title">روش تدریس من</h2>
        <div className="method-content">
          <div className="method-text">
            {methods.map((method, index) => (
              <div key={index} className="method-item card-base card-light-sweep card-overlay">
                <div className="method-icon">
                  <i className={method.icon} aria-hidden="true"></i>
                </div>
                <div className="method-details">
                  <h3>{method.title}</h3>
                  <p>{method.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="method-image">
            <div className="method-placeholder">
              <img 
                src="/images/teacher3.webp" 
                alt="روش تدریس مدرس ریاضی" 
                className="method-profile-image" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Method 